export default __webpack_public_path__ + "1e529efb5046c90b3a4e430eb880de2f.png";